import React, { Component, button } from "react";
import { Director, View } from "@millicast/sdk";
import Slider from "../components/Slider";
import AudioButtons from "../components/AudioButtons";
import { getStream } from "../service/MatchListService";
import { FaInfoCircle } from "react-icons/fa";

const audio = document.createElement("audio");
const audioCommentator = document.createElement("audio");

class Player extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: 0,
      delayValue: 0,
      audioType: "referee",
      commentatorUrl: null,
      isPlaying: false,
      isLoading: 0,
      expandInfo: false,
    };
    this.millicastView = null;
    this.millicastViewCommentator = null;
    this.audioContext = null;
    this.audioCommentatorContext = null;
    this.delayNode = null;
    this.commentatorDelayNode = null;
    this.maxDelay = 30; // max delay in seconds
  }
  componentDidMount() {
    const href = new URL(window.location.href);
    const _audioType = href.searchParams.get("type");
    if (!this.state.isPlaying) {
      this.loadStream();
    }
    if (_audioType === "referee") {
      this.commentatorStream();
    }
  }

  commentatorStream = async () => {
    try {
      const href = new URL(window.location.href);
      const matchId = href.searchParams.get("matchId");
      if (matchId) {
        const result = await getStream(matchId);
        console.log(
          "result?.milliCastCommentaryUrl",
          result?.milliCastCommentaryUrl
        );
        if (result?.milliCastCommentaryUrl) {
          this.setState({ commentatorUrl: result?.milliCastCommentaryUrl });
          // this.loadStreamCommentator(result?.milliCastCommentaryUrl);
        }
        console.log("result", result);
      }
    } catch (error) {
      console.log("refereeStream err", error);
    }
  };

  playstream = () => {
    if (this.state.audioType === "commentator") {
      this.loadStreamCommentator();
    } else {
      this.loadStream();
    }
  };

  loadStream = async () => {
    this.setState({ isLoading: 1 });
    const _href = new URL(window.location.href);
    const _streamName = _href.searchParams.get("streamName");
    const _streamAccountId = _href.searchParams.get("streamAccountId");
    console.log("streamName", _streamName, "streamAccountId", _streamAccountId);

    const AudioContext = window.AudioContext;
    this.audioContext = new AudioContext();
    this.delayNode = this.audioContext.createDelay(30.0);
    this.delayNode.delayTime.value = this.state.delayValue;

    const tokenGenerator = () =>
      Director.getSubscriber({
        streamName: _streamName, //'l2a8e5y6',
        streamAccountId: _streamAccountId, //'4P2QPW'
      });
    // Create audio context
    // millicastView = null;
    this.millicastView = new View(_streamName, tokenGenerator, null);
    this.millicastView.on("track", ({ track }) => {
      // Ignore non audio tracks
      if (track.kind !== "audio") {
        return;
      }
      // this.delayNode.delayTime.value = this.state.delayValue;
      const stream = (window.stream = new MediaStream([track]));

      audio.srcObject = stream;
      // audio.muted = true
      // if (this.state.delayValue > 0) {
      audio.muted = true;
      // }
      audio.play();

      // Create media source
      var source = null;
      source = this.audioContext.createMediaStreamSource(stream);

      // Creat primary graph, connect webrtc with the delay node and play it in the default destination
      source.connect(this.delayNode).connect(this.audioContext.destination);
      console.log(
        "this.delayNode.delayTime.value",
        this.delayNode.delayTime.value
      );
    });

    try {
      await this.millicastView.connect();
      this.setState({ isLoading: 0, hasError: 0, isPlaying: true });
      console.log("Stream connected successfully");
    } catch (error) {
      this.setState({ isLoading: 0, hasError: 1 });
      console.error("Error connecting to stream:", error);
    }
  };

  loadStreamCommentator = async () => {
    this.setState({ isLoading: 2 });
    const _href = new URL(this.state.commentatorUrl);
    const _streamName = _href.searchParams.get("streamName");
    const _streamAccountId = _href.searchParams.get("streamAccountId");
    console.log("streamName", _streamName, "streamAccountId", _streamAccountId);

    const AudioContext = window.AudioContext;
    this.audioCommentatorContext = new AudioContext();
    this.commentatorDelayNode = this.audioCommentatorContext.createDelay(30.0);
    this.commentatorDelayNode.delayTime.value = this.state.delayValue;

    const tokenGenerator = () =>
      Director.getSubscriber({
        streamName: _streamName, //'l2a8e5y6',
        streamAccountId: _streamAccountId, //'4P2QPW'
      });

    this.millicastViewCommentator = new View(_streamName, tokenGenerator, null);
    this.millicastViewCommentator.on("track", ({ track }) => {
      if (track.kind !== "audio") {
        return;
      }
      // this.commentatorDelayNode.delayTime.value = this.state.delayValue;
      const stream = (window.stream = new MediaStream([track]));

      audioCommentator.srcObject = stream;

      // if (this.state.delayValue > 0) {
      //   audioCommentator.muted = true;
      // }
      audioCommentator.muted = true;
      audioCommentator.play();
      // if (audioCommentator) {

      // }

      var source = null;
      source = this.audioCommentatorContext.createMediaStreamSource(stream);

      source
        .connect(this.commentatorDelayNode)
        .connect(this.audioCommentatorContext.destination);
      console.log(
        "this.delayNode.delayTime.value",
        this.commentatorDelayNode.delayTime.value
      );
    });

    try {
      await this.millicastViewCommentator.connect();
      this.setState({ isLoading: 0, hasError: 0 });
      console.log("Stream connected successfully");
    } catch (error) {
      this.setState({ isLoading: 0, hasError: 1 });
      console.error("Error connecting to stream:", error);
    }
  };

  stopStream = async () => {
    console.log("stopStream");

    if (audio && audio.srcObject) {
      const tracks = audio.srcObject.getTracks();
      tracks.forEach((track) => track.stop());

      audio.pause();
      audio.srcObject = null;
    }

    if (this.delayNode) {
      console.log("delay stop", this.delayNode);

      this.delayNode.disconnect();
    }

    if (this.audioContext) {
      // Force stop any audio processing
      try {
        await this.audioContext.close(); // This halts everything
        this.audioContext = null; // Optional: Reset if you'll create new later
      } catch (err) {
        console.warn("Error closing AudioContext:", err);
      }
    }

    if (this.millicastView) {
      this.millicastView.stop();
    }

    this.loadStreamCommentator();
    return Promise.resolve();
  };

  stopStreamCommentator = async () => {
    if (audioCommentator && audioCommentator.srcObject) {
      const tracks = audioCommentator.srcObject.getTracks();
      tracks.forEach((track) => track.stop());

      audioCommentator.pause();
      audioCommentator.srcObject = null;
    }

    if (this.delayNode) {
      this.delayNode.disconnect();
    }

    if (this.audioCommentatorContext) {
      // Force stop any audio processing
      try {
        await this.audioCommentatorContext.close(); // This halts everything
        this.audioCommentatorContext = null; // Optional: Reset if you'll create new later
      } catch (err) {
        console.warn("Error closing audioCommentatorContext:", err);
      }
    }

    if (this.millicastViewCommentator) {
      this.millicastViewCommentator.stop();
    }

    this.loadStream();
    return Promise.resolve();
  };

  delayStream = (delay) => {
    if (this.state.isLoading != 0) {
      return;
    }
    if (this.state.audioType === "commentator") {
      if (this.commentatorDelayNode && this.audioCommentatorContext) {
        if (this.audioCommentatorContext.state === "suspended") {
          this.audioCommentatorContext.resume();
        }
        this.commentatorDelayNode.delayTime.setValueAtTime(
          delay,
          this.audioCommentatorContext.currentTime
        );
        console.log(
          "this.commentatorDelayNode.delayTime",
          this.commentatorDelayNode.delayTime
        );
      }
    } else {
      if (this.delayNode && this.audioContext) {
        if (this.audioContext.state === "suspended") {
          this.audioContext.resume();
        }
        this.delayNode.delayTime.setValueAtTime(
          delay,
          this.audioContext.currentTime
        );
        console.log("this.delayNode.delayTime", this.delayNode.delayTime);
      }
    }

    this.setState({ delayValue: delay }, () => {
      console.log("State delayValue updated:", this.state.delayValue);
    });
  };

  changeAudio = (type) => {
    if (this.state.isLoading != 0) {
      return;
    }
    if (type === "commentator") {
      this.stopStream();
    } else {
      this.stopStreamCommentator();
    }
    this.setState({ audioType: type });
  };

  render() {
    return this.state.hasError == 1 ? (
      <div style={{ paddingTop: "10%" }}>
        <div className="feed-wrap">
          <span className="alert alert-warning">No direct feed available</span>
          {/* <br /> */}
          <button
            onTouchStart={() => this.playstream()}
            style={{ background: "none", border: "none" }}
          >
            <img
              src="Refresh-white-arrow-icon.png"
              alt="Refresh"
              style={{ display: "block", pointerEvents: "none" }}
              width="35"
              height="35"
            />
          </button>
        </div>
        <div style={{ paddingTop: "5.5%" }}>
          {this.state.commentatorUrl && (
            <AudioButtons
              audioType={this.state.audioType}
              changeAudio={this.changeAudio}
              isLoading={this.state.isLoading}
              eventType={"touch"}
            />
          )}
        </div>
      </div>
    ) : (
      this.state.hasError == 0 && (
        <div>
          <span>Direct feed</span>
          <Slider
            delayValue={this.state.delayValue}
            delayStream={this.delayStream}
            isLoading={this.state.isLoading}
            eventType={"touch"}
          />

          {this.state.commentatorUrl && (
            <AudioButtons
              audioType={this.state.audioType}
              changeAudio={this.changeAudio}
              isLoading={this.state.isLoading}
              eventType={"touch"}
            />
          )}
          {!this.state.expandInfo && (
            <div
              className="icon-container"
              onTouchStart={() =>
                this.setState({ expandInfo: !this.state.expandInfo })
              }
            >
              <FaInfoCircle size={25} color="#2563eb" />
            </div>
          )}
          {this.state.expandInfo && (
            <div
              style={styles.container}
              onTouchStart={() =>
                this.setState({ expandInfo: !this.state.expandInfo })
              }
            >
              <FaInfoCircle size={25} color="#2563eb" />
              <div style={styles.message}>
                Ensure your phone isn’t on silent and volume is turned up.
              </div>
            </div>
          )}
          {/* <button onClick={ () => this.playstream()}>
      Click me!
    </button> */}
        </div>
      )
    );
  }
}

const styles = {
  container: {
    display: "flex",
    gap: "5px",
    alignItems: "center",
    backgroundColor: "#eff6ff",
    border: "1px solid #bfdbfe",
    borderRadius: "12px",
    padding: "8px",
    paddingHorizontal: "12px",
    color: "#1e3a8a",
    width: "fit-content",
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "85%",
    marginTop: "5px",
    marginBottom: "5px",
  },
  message: {
    fontSize: "14px",
  },
};

export default Player;
